import loadable from 'react-loadable';

const LoadableSelectGoogleContactsModal = loadable({
    loader: () => import(/* webpackChunkName: "select-google-contacts" */ './SelectGoogleContactsModal'),
    loading: () => null,
});

export default LoadableSelectGoogleContactsModal;
